import React from 'react';

const CompaniesIcon = function CompaniesIcon() {
  return (
    <svg
      width="22px"
      height="22px"
      viewBox="0 0 22 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className="bin-icon"
    >
      <g id="Client-Prototype" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Companies-edit" transform="translate(-1197.000000, -197.000000)">
          <g id="Group-56" transform="translate(1184.000000, 189.000000)">
            <g id="delete_black_24dp-(1)" transform="translate(13.000000, 8.000000)">
              <polygon id="Path" points="0 0 22 0 22 22 0 22" />
              <path d="M14.6666667,8.25 L14.6666667,17.4166667 L7.33333333,17.4166667 L7.33333333,8.25 L14.6666667,8.25 M13.2916667,2.75 L8.70833333,2.75 L7.79166667,3.66666667 L4.58333333,3.66666667 L4.58333333,5.5 L17.4166667,5.5 L17.4166667,3.66666667 L14.2083333,3.66666667 L13.2916667,2.75 Z M16.5,6.41666667 L5.5,6.41666667 L5.5,17.4166667 C5.5,18.425 6.325,19.25 7.33333333,19.25 L14.6666667,19.25 C15.675,19.25 16.5,18.425 16.5,17.4166667 L16.5,6.41666667 Z" id="Shape" fill="#424B50" fillRule="nonzero" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default CompaniesIcon;
